import { useRouter } from 'next/router';

export const useLocaleHook = (): string => {
  const router = useRouter();
  const { locale } = router;
  return locale || 'uk';
};
